import { Component } from 'react';
import styled from 'styled-components';

import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import { SportsItemStyle } from './sportsCommonStyle';

interface IProps {
  url: string;
  teamHome: string;
  teamVisitor: string;
  dataClParams: string;
}

const BaseballItem = styled.li`
  ${SportsItemStyle}
`;

const BaseballLink = styled.a`
  ${pcVisitedLink}
`;

export default class BaseballGame extends Component<IProps> {
  /**
   *
   */
  public render() {
    return (
      <BaseballItem>
        <BaseballLink
          href={this.props.url}
          data-cl-params={this.props.dataClParams}
        >{`${this.props.teamHome} vs. ${this.props.teamVisitor}`}</BaseballLink>
      </BaseballItem>
    );
  }
}
